var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "1680",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column align-stretch",
    attrs: {
      "height": "90vh"
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.text_title) + " "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _c('dialog-excel-upload-header', _vm._b({
    staticClass: "px-4",
    staticStyle: {
      "flex": "0 0 auto"
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'dialog-excel-upload-header', {
    excel: _vm.excel
  }, false)), _c('v-divider'), _c('dialog-excel-upload-table', _vm._b({
    staticClass: "d-flex flex-column fill-height",
    staticStyle: {
      "position": "relative",
      "flex": "0 0 calc(90vh - 58px - 1px - 56px - 1px - 1px - 52px)",
      "overflow": "hidden"
    },
    model: {
      value: _vm.orders,
      callback: function callback($$v) {
        _vm.orders = $$v;
      },
      expression: "orders"
    }
  }, 'dialog-excel-upload-table', {
    type: _vm.type,
    excel: _vm.excel,
    loading: _vm.loading
  }, false)), _c('v-divider'), _c('v-card-actions', {
    staticStyle: {
      "flex": "0 0 auto"
    }
  }, [_c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    disabled: _vm.disabled,
    loading: _vm.loading
  }, false), [_vm._v(_vm._s(_vm.text_action))])], 1), _c('dialog-excel-upload-logic', _vm._b({
    staticStyle: {
      "flex": "0 0 auto"
    },
    on: {
      "loading": function loading(value) {
        return _vm.loading = value;
      }
    },
    model: {
      value: _vm.orders,
      callback: function callback($$v) {
        _vm.orders = $$v;
      },
      expression: "orders"
    }
  }, 'dialog-excel-upload-logic', {
    type: _vm.type,
    file: _vm.file
  }, false)), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "absolute": "",
      "light": "",
      "color": "white"
    }
  }, [_c('v-sheet', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "width": "320",
      "rounded": ""
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "value": _vm.updatedLength / _vm.orders.length * 100,
      "height": "32"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.updatedLength) + " / " + _vm._s(_vm.orders_computed.length) + " ")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }